import { ErrorHandler, inject, Injectable } from '@angular/core';
import { Tracker } from '@core/services/event-tracker.service';
import { IdleCallbackService } from '@core/services/idle-callback.service';
import { ScriptLoaderService } from '@core/services/script-loader.service';
import { WINDOW } from '@core/services/window.service';
import {
    AnalyticsEventName,
    leadGenerationEvents,
} from '@core/utils/AnalyticsEvents';
import { environment } from '@environment/environment';
import { switchMap, tap } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class TapfiliateService implements Tracker {
    private scriptLoaderService = inject(ScriptLoaderService);
    private window = inject<Window & { tap: any }>(WINDOW);
    private idleCallbackService = inject(IdleCallbackService);
    private errorHandler = inject(ErrorHandler);

    readonly ACCOUNT_ID = environment.tapfiliate.accountId;

    constructor() {}

    setup(): void {
        const loadScript = this.scriptLoaderService
            .load('https://script.tapfiliate.com/tapfiliate.js')
            .pipe(
                tap(() => {
                    this.window.tap('create', this.ACCOUNT_ID, {
                        integration: 'javascript',
                    });
                    this.window.tap('detect');
                })
            );
        this.idleCallbackService
            .firstIdleCallback()
            .pipe(switchMap(() => loadScript))
            .subscribe();
    }

    trackLead(customerId: string, eventName: AnalyticsEventName): void {
        this.window.tap('lead', customerId, {
            event: eventName,
        });
    }

    trackConversion(): void {
        console.error('conversion. Not Implemented');
    }
    trackEvent(
        name: AnalyticsEventName,
        props?: { [key: string]: string | number | boolean }
    ): void {
        try {
            if (leadGenerationEvents.includes(name) && props?.customerId) {
                this.trackLead(props.customerId.toString(), name);
            }
        } catch (error) {
            this.errorHandler.handleError(error);
        }
    }
}
